// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/tradesHeader.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tradesContainer {
  height: 85%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 97%;
  height: 100dvh;
  padding: 10px;
}
@media (min-width: 450px) {
  .tradesContainer {
    width: 400px;
  }
}
@media only screen and (max-height: 712px) {
  .tradesContainer {
    height: 100%;
  }
}
.tradesContainer .header {
  width: 100%;
  height: 100px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  border-radius: 20px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;
}
.tradesContainer .header h1 {
  color: #FFFFFF;
  text-align: center;
  font-family: "Crimson Pro", serif;
  font-size: 40px;
  font-weight: 900;
  margin-top: 20px;
}
@media (max-width: 450px) {
  .tradesContainer .header h1 {
    font-size: 30px;
  }
}
.tradesContainer .header::after {
  content: "";
  position: absolute;
  border-radius: 10px;
  inset: 0;
  padding: 10px;
  border: 3px solid transparent;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B) border-box;
  -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
}
.tradesContainer .tradeCards {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
}
.tradesContainer .tradeCards .tradeCard {
  min-width: 170px;
  flex: 1 1;
  padding: 10px;
  background-color: rgba(105, 155, 182, 0.2);
  border-radius: 16px;
}
@media (max-width: 420px) {
  .tradesContainer .tradeCards .tradeCard {
    padding: 20px;
  }
}
.tradesContainer .tradeCards .tradeCard .diamondImg {
  background-repeat: no-repeat;
  background-position: center;
  width: 68px;
  height: 68px;
  background-size: 100% 100%;
  margin: 0 auto;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading h1 {
  margin: 0;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading .title, .tradesContainer .tradeCards .tradeCard .tradeHeading .price {
  color: #FFFFFF;
  font-family: "Crimson Pro", serif;
  font-size: 17px;
  margin-bottom: 0px;
  color: #FFFFFF;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading .price {
  color: rgb(41, 136, 41);
  font-family: "Roboto", sans-serif;
  font-size: 18px;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading .title {
  margin-top: 5px;
}
.tradesContainer .tradeCards .tradeCard .tradeHeading .description {
  color: #699BB6;
  font-family: "Roboto", sans-serif;
  text-align: center;
  font-size: 12px;
  margin: 0;
  line-height: 120%;
  height: 40px;
  margin-top: 5px;
}
.tradesContainer .tradeCards .tradeCard .buyButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60%;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  font-weight: 600;
  padding: 8px 0px;
  border-radius: 20px;
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  border: 0px solid;
  bottom: 30px;
  margin: 0 auto;
  margin-top: 15px;
  cursor: pointer;
}
@media (max-width: 420px) {
  .tradesContainer .tradeCards .tradeCard .buyButton {
    padding: 8px 0px;
  }
}
.tradesContainer .tradeCards .tradeCard .disabled {
  background: #575757;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/modules/diamonds/trades/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAII;EAII,WAAA;EAIA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AARR;AAJQ;EADJ;IAEQ,YAAA;EAOV;AACF;AALQ;EALJ;IAMQ,YAAA;EAQV;AACF;AADQ;EACI,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAGZ;AAFY;EACI,cC5BH;ED6BG,kBAAA;EACA,iCE5BF;EF6BE,eAAA;EACA,gBAAA;EACA,gBAAA;AAIhB;AAHgB;EAPJ;IAQQ,eAAA;EAMlB;AACF;AAHQ;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,6BAAA;EACA,kEAAA;EACA,8EAAA;EAEA,uBAAA;AAKZ;AAFQ;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;AAIZ;AAHY;EACI,gBAAA;EACA,SAAA;EACA,aAAA;EAIA,0CAAA;EACA,mBAAA;AAEhB;AANgB;EAJJ;IAKQ,aAAA;EASlB;AACF;AALgB;EACI,4BAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,cAAA;AAOpB;AALgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAOpB;AANoB;EACI,SAAA;AAQxB;AANoB;EACI,cCrFX;EDsFW,iCEpFV;EFqFU,eAAA;EACA,kBAAA;EACA,cCzFX;ADiGb;AANoB;EACI,uBAAA;EACA,iCExFf;EFyFe,eAAA;AAQxB;AALoB;EACI,eAAA;AAOxB;AALoB;EACI,cCpGP;EDqGO,iCEjGf;EFkGe,kBAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AAOxB;AAHgB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,uDAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cC1HP;ED2HO,iCEtHX;EFuHW,eAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAKpB;AAJoB;EAlBJ;IAmBQ,gBAAA;EAOtB;AACF;AALgB;EACI,mBAAA;EACA,YAAA;AAOpB","sourcesContent":["@import '../../../scss/colors.scss';\n@import '../../../scss/fonts.scss';\n\n  \n    .tradesContainer{\n        @media (min-width: 450px){\n            width: 400px;\n        }\n        height: 85%;\n        @media only screen and (max-height: 712px) {\n            height: 100%;\n        }\n        display: flex;\n        align-items: flex-start;\n        flex-direction: column;\n        width: 97%;\n        height: 100dvh;\n        padding: 10px;\n        .header{\n            width:  100%;\n            height: 100px;\n            background-image: url('../../../assets/img/tradesHeader.png');\n            background-size: cover;\n            border-radius: 20px;\n            margin: 0 auto;\n            margin-top: 50px;\n            position: relative;\n            h1{\n                color: $color-White;\n                text-align: center;\n                font-family: $Crimson-Pro;\n                font-size: 40px;\n                font-weight: 900;\n                margin-top: 20px;\n                @media (max-width: 450px){\n                    font-size: 30px;\n                }\n            }\n        }\n        .header::after{\n            content: '';\n            position: absolute;\n            border-radius: 10px; \n            inset: 0;\n            padding: 10px; \n            border: 3px solid transparent; \n            background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2) border-box;\n            -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);\n            -webkit-mask-composite: xor; \n            mask-composite: exclude;\n\n        }\n        .tradeCards{\n            margin-top: 20px;\n            display: flex;\n            gap: 10px;\n            flex-wrap: wrap;\n            justify-content: center;\n            .tradeCard{\n                min-width: 170px;\n                flex: 1;\n                padding: 10px;\n                @media (max-width: 420px){\n                    padding: 20px;\n                }\n                background-color: rgba($color: $color-Secondary, $alpha: 0.2) ;\n                border-radius: 16px;\n            \n                .diamondImg{\n                    background-repeat: no-repeat;\n                    background-position: center;\n                    width: 68px;\n                    height: 68px;\n                    background-size: 100% 100%; \n                    margin: 0 auto;\n                }\n                .tradeHeading{\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    h1{\n                        margin:  0 ;\n                    }\n                    .title , .price{\n                        color: $color-White;\n                        font-family: $Crimson-Pro;\n                        font-size: 17px;\n                        margin-bottom: 0px;\n                        color: $color-White;\n                    }\n                    .price{\n                        color: rgb(41, 136, 41);\n                        font-family: $Roboto;\n                        font-size: 18px;\n\n                    }\n                    .title{\n                        margin-top:5px;\n                    }\n                    .description{\n                        color: $color-Secondary;\n                        font-family: $Roboto;\n                        text-align: center;\n                        font-size: 12px;\n                        margin: 0;\n                        line-height: 120%;\n                        height: 40px;\n                        margin-top: 5px;\n\n                    }\n                }\n                .buyButton{\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    width: 60%;\n                    background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n                    font-weight: 600;\n                    padding: 8px 0px;\n                    border-radius: 20px;\n                    text-align: center;\n                    color: $color-White;\n                    font-family: $Roboto;\n                    font-size: 16px;\n                    border:0px solid;\n                    bottom: 30px;\n                    margin: 0 auto;\n                    margin-top: 15px;\n                    cursor: pointer;\n                    @media (max-width: 420px){\n                        padding: 8px 0px;\n                    }\n                }\n                .disabled{\n                    background: #575757 ;\n                    opacity: 0.5;\n                }\n            }\n        }\n    }\n","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
